import { ETheme, EThemeBackground } from "@/common/entity/Enum";
import styled from "styled-components";

export const AttendeeBaseWrapper = styled.div<{ $height?: number }>`
  width: 100%;
  height: 100%;
  .BaseCanvasWrapper {
    height: 100%;
  }
  .rc_accordionPanel_content {
    height: ${(props) => (props.$height ? props.$height + "px" : "100%")};
    overflow-y: auto;
  }
`;

export const AttendeeInfoWrapper = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 16px;
  }

  .content-tooltip {
    border-left: 3px solid #106ebe;
    padding: 8px;
    width: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .content-detail {
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .item-detail {
    display: flex;
    align-items: center;
  }
  .avatar {
    padding-right: 11px;
  }
`;

export const StickyElementWrapper = styled.div<{ $theme?: string }>`
  height: 40px;
  margin-left: -2px;
  overflow-x: hidden;
  position: sticky;
  bottom: 0;
  padding: 0px 15px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background: ${(props) =>
    props.$theme === ETheme.Dark
      ? EThemeBackground.Dark
      : EThemeBackground.Light};
`;

export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -6px;
`;

export const AttendeeButtonsWrapper = styled.div`
  display: flex;
  word-break: break-all;
  width: 100%;
  .content-tooltip {
    border-left: 3px solid #106ebe;
    padding: 8px;
    width: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .content-detail {
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .item-detail {
    display: flex;
    align-items: center;
  }
  .avatar {
    padding-right: 5px;
    padding-top: 2px;
  }
  .detail-email {
    margin-top: -3px;
    margin-left: 2px;
  }
  .avatar-name {
    margin-left: -2px;
  }
`;
